import { useCallback } from "react";

import { useChatSendMessage } from "~/queries";
import { useChatAuthAccessToken } from "~/ui/context";

export const useSendMessage = (chatId: number) => {
  const accessToken = useChatAuthAccessToken();

  const {
    mutateAsync: sendMessageAsync,
    isLoading: isMessageSending,
  } = useChatSendMessage();

  const sendMessage = useCallback(
    (message: string, successCb: () => void) => {
      sendMessageAsync([
        chatId,
        accessToken,
        {
          message,
        },
      ]).then(successCb);
    },
    [accessToken, chatId, sendMessageAsync]
  );

  return { sendMessage, isMessageSending };
};
